import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

const ContactWithEmail = () => {
  const form = useRef();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let isValid = true;
    const updatedErrors = {};

    if (!formData.name.trim()) {
      updatedErrors.name = "Name is required";
      isValid = false;
    }

    if (!formData.email.trim()) {
      updatedErrors.email = "Email is required";
      isValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      updatedErrors.email = "Invalid email address";
      isValid = false;
    }

    if (!formData.phone.trim()) {
      updatedErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      updatedErrors.phone = "Invalid mobile number";
      isValid = false;
    }

    setErrors(updatedErrors);

    // If validation is successful, send email
    if (isValid) {
      emailjs
        .sendForm("service_wnurmwh", "template_hh7v1jj", form.current, {
          publicKey: "z1I1sAFDvdmsXTfUx",
        })
        .then(() => {
          console.log("SUCCESS!");
          setFormData({
            name: "",
            email: "",
            phone: "",
            message: "",
          });
          setSuccessMessage("Message sent successfully!");
        })
        .catch((error) => {
          console.log("FAILED...", error.text);
          setErrorMessage("Failed to send message. Please try again later.");
        });
    }
  };

  return (
    <>
      <form
        ref={form}
        onSubmit={handleSubmit}
        className="mb-12 w-full shrink-0 grow-0 basis-auto md:px-3 lg:mb-0 lg:w-5/12 lg:px-6"
      >
        <div className="mb-3 w-full">
          <label
            className="block font-medium mb-[2px] text-teal-700"
            htmlFor="exampleInput90"
          >
            Name
          </label>
          <input
            type="text"
            className={`px-2 py-2 border w-full outline-none rounded-md ${
              errors.name && "border-red-500"
            }`}
            id="exampleInput90"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
          />
          {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
        </div>
        <div className="mb-3 w-full">
          <label
            className="block font-medium mb-[2px] text-teal-700"
            htmlFor="exampleInput90"
          >
            Phone
          </label>
          <input
            type="text"
            className={`px-2 py-2 border w-full outline-none rounded-md ${
              errors.phone && "border-red-500"
            }`}
            id="exampleInput90"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter your phone number"
          />
          {errors.phone && (
            <p className="text-red-500 text-sm">{errors.phone}</p>
          )}
        </div>

        <div className="mb-3 w-full">
          <label
            className="block font-medium mb-[2px] text-teal-700"
            htmlFor="exampleInput90"
          >
            Email
          </label>
          <input
            type="text"
            className={`px-2 py-2 border w-full outline-none rounded-md ${
              errors.email && "border-red-500"
            }`}
            id="exampleInput90"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email address"
          />
          {errors.email && (
            <p className="text-red-500 text-sm">{errors.email}</p>
          )}
        </div>

        <div className="mb-3 w-full">
          <label
            className="block font-medium mb-[2px] text-teal-700"
            htmlFor="exampleInput90"
          >
            Message
          </label>
          <textarea
            className="px-2 py-2 border rounded-[5px] w-full outline-none"
            name="message"
            id=""
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>

        <button
          type="submit"
          className="mb-6 inline-block w-full rounded bg-teal-400 px-6 py-2.5 font-medium uppercase leading-normal text-white hover:shadow-md hover:bg-teal-500"
        >
          <span>Send</span>
        </button>
      </form>
      {successMessage && <p className="text-teal-500">{successMessage}</p>}
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </>
  );
};

export default ContactWithEmail;
